import React from "react";
import cn from "classnames";
import ModalDatePicker from "@otrl/ui/components/date/ModalDatePicker";

import { noop } from "lib/utils";
import DateTime from "models/DateTime";
import useModal from "hooks/useModal";
import ErrorMessage from "components/ui/ErrorMessage";
import DateTimeInput from "components/datetime/DateTimeInput";
import OpenReturn from "components/datetime/OpenReturn";
import "styles/components/dates-selector.scss";

const DatesSelector = ({
  errors,
  fromDateTime = new DateTime(),
  isCustomLength = false,
  isSeason = false,
  isOther = false,
  onChangeFromDateTime = noop,
  onChangeToDateTime = noop,
  ticketType,
  toDateTime = new DateTime(),
  maxDate,
  maxEndDate,
  minDate,
  disableTimePicker = false,
  rightAlignPopup = false,
}) => {
  const { closeModal, showModal } = useModal();

  const handleFromDateSave = selectedDateTime => {
    onChangeFromDateTime({ dateTime: selectedDateTime });
  };

  const handleToDateSave = selectedDateTime => {
    onChangeToDateTime({ dateTime: selectedDateTime });
  };

  const handleFromDateModal = () => {
    showModal(
      <ModalDatePicker
        dateTime={fromDateTime}
        isSeason={isSeason}
        isOther={isOther}
        onClose={closeModal}
        onSave={handleFromDateSave}
        maxDate={maxDate}
        minDate={minDate}
        disableTimePicker={disableTimePicker}
      />
    );
  };

  const handleToDateModal = () => {
    showModal(
      <ModalDatePicker
        dateTime={toDateTime}
        isReturn
        isSeason={isSeason}
        isOther={isOther}
        onClose={closeModal}
        onSave={handleToDateSave}
        maxDate={maxEndDate ?? maxDate}
        minDate={minDate}
        disableTimePicker={disableTimePicker}
      />
    );
  };

  const isError = Object.keys(errors).some(errorType =>
    ["fromDateTime", "toDateTime"].includes(errorType)
  );
  const showEndDate = ticketType === "return" || isCustomLength;

  return (
    <div className="otrl-jp__dates-selector-container">
      <div className={cn("otrl-jp__dates-selector")}>
        <DateTimeInput
          dateTime={fromDateTime}
          isError={isError}
          isSeason={isSeason}
          isOther={isOther}
          precedesReturn={showEndDate}
          mobileLabel="Outbound"
          onChange={onChangeFromDateTime}
          onModalRequest={handleFromDateModal}
          short={ticketType !== "single"}
          maxDate={maxDate}
          minDate={minDate}
          disableTimePicker={disableTimePicker}
          rightAlignPopup={rightAlignPopup}
        />
        {showEndDate && (
          <React.Fragment>
            <div className={cn("otrl-jp__divider-line")} />
            <DateTimeInput
              dateTime={toDateTime}
              isError={isError}
              isSeason={isSeason}
              isOther={isOther}
              isReturn
              mobileLabel="Return"
              onChange={onChangeToDateTime}
              onModalRequest={handleToDateModal}
              short
              maxDate={maxEndDate ?? maxDate}
              minDate={minDate}
              disableTimePicker={disableTimePicker}
              rightAlignPopup
            />
          </React.Fragment>
        )}
        {ticketType === "open" && <OpenReturn />}
      </div>
      {<ErrorMessage errors={errors} name={["toDateTime", "fromDateTime"]} />}
    </div>
  );
};

export default DatesSelector;
